module.exports = __webpack_public_path__ + "static/img/045 1.5305b610.jpg";